import sanitizeHtml from 'sanitize-html';

const clean = (string) => {
    return sanitizeHtml(string, { disallowedTagsMode: 'escape' });
};

export { clean };
